'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mobx = require('mobx');

var _upperFirst = require('lodash/upperFirst');

var _upperFirst2 = _interopRequireDefault(_upperFirst);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (state, property) {
  var _ref;

  var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


  var setValue = (0, _mobx.action)('Value ' + property + ' - Set value', function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
    return state[property] = value;
  });
  var extendValue = (0, _mobx.action)('Value ' + property + ' - Extend value', function () {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initial;
    return (0, _mobx.extendObservable)(state[property], value);
  });

  var methodSuffix = (0, _upperFirst2.default)(property);

  // Because why not yeah
  return _ref = {}, _defineProperty(_ref, 'set' + methodSuffix, setValue), _defineProperty(_ref, 'extend' + methodSuffix, extendValue), _ref;
};